module.exports = __webpack_public_path__ + "HelveticaLight.abd1ed391484d1cb97ee.woff";


//////////////////
// WEBPACK FOOTER
// /var/www/minha-at3-cliente/src/app/@theme/fontes/Helvetica/HelveticaLight.woff
// module id = ../../../../../src/app/@theme/fontes/Helvetica/HelveticaLight.woff
// module chunks = styles